// Need React for cloneElement

import { Row, Col, Card, Typography, Space, Divider } from "antd";
import {
  ShopOutlined,
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { CopyableText } from "./Atoms";
import { BookPartner } from "./PartnerBooking";

const { Text } = Typography;

function InfoField({ label, value, isPhoneNumber = false, showCopy = true }) {
  return (
    <div style={{ marginBottom: 10 }}>
      {label && (
        <Text
          style={{
            display: "block",
            fontSize: 12,
            fontWeight: 700,
            color: "#94A3B8",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            marginBottom: 2,
          }}
        >
          {label}
        </Text>
      )}
      <Space size={5} align="start">
        {showCopy && value && (
          <CopyableText
            style={{
              color: isPhoneNumber ? "#3b82f6" : "inherit",
            }}
            text={value}
            linkType={isPhoneNumber ? "phone_number" : ""}
          />
        )}
        {(!showCopy || (showCopy && !value)) && (
          <Text
            style={{
              fontWeight: 500,
              color: "#1E293B",
            }}
          >
            {value || "—"}
          </Text>
        )}
      </Space>
    </div>
  );
}

const CARD_STYLE = {
  borderRadius: 12,
  border: "1px solid #E2E8F0",
  boxShadow: "none",
};

const CARD_HEAD_STYLE = {
  borderBottom: "1px solid #F1F5F9",
  padding: "12px 18px",
  minHeight: "unset",
};

const CARD_BODY_STYLE = { padding: "14px 18px" };

export default function InfoCards({ record }) {
  const outlet = record.outlet;
  const customer = record.customer;

  const customerAddressUrl = `https://www.google.com/maps/search/?api=1&query=${customer.address.latitude},${customer.address.longitude}`;
  const outletAddressUrl = `https://www.google.com/maps/search/?api=1&query=${outlet.address.latitude},${outlet.address.longitude}`;

  return (
    <Row gutter={14} style={{ marginBottom: 20 }}>
      {/* Outlet Card */}
      <Col span={12}>
        <Card
          style={CARD_STYLE}
          headStyle={CARD_HEAD_STYLE}
          bodyStyle={CARD_BODY_STYLE}
          title={
            <Space size={10}>
              <span
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 9,
                  background: "#EFF6FF",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <ShopOutlined style={{ fontSize: 16, color: "#1D4ED8" }} />
              </span>
              <InfoField value={outlet.name} />
            </Space>
          }
        >
          <Row gutter={[12, 12]} style={{ marginBottom: 18 }}>
            <Col span={12}>
              <InfoField
                icon={<PhoneOutlined />}
                label="Phone"
                value={outlet.phone_number}
                isPhoneNumber={true}
              />
            </Col>
            <Col span={12}>
              <InfoField label="Brand" value={outlet.brand_id} />
            </Col>
          </Row>
          <Row gutter={[12, 12]}>
            <Col span={12}>
              <a href={outletAddressUrl} target="_blank" rel="noreferrer">
                See outlet address on map
                <EnvironmentOutlined style={{ marginLeft: "0.5rem" }} />
              </a>
            </Col>
          </Row>
          <Divider />
          <Row gutter={[12, 12]}>
            <Col span={24}>
              <BookPartner
                placed_order_id={record.placed_order_id}
                attempts={record.deliveries}
              />
            </Col>
          </Row>
        </Card>
      </Col>

      {/* Customer Card */}
      <Col span={12}>
        <Card
          style={CARD_STYLE}
          headStyle={CARD_HEAD_STYLE}
          bodyStyle={CARD_BODY_STYLE}
          title={
            <Space size={10}>
              <span
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 9,
                  background: "#F0FDF4",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <UserOutlined style={{ fontSize: 16, color: "#15803D" }} />
              </span>
              <InfoField value={customer.name} />
            </Space>
          }
        >
          <Row gutter={[12, 12]} style={{ marginBottom: 18 }}>
            <Col span={12}>
              <InfoField
                icon={<PhoneOutlined />}
                label="Phone"
                value={customer.phone_number}
                isPhoneNumber={true}
              />
            </Col>
            <Col span={12}>
              <InfoField
                label="Order Slot"
                value={`${customer.order_slot || "NA"}`}
                showCopy={false}
              />
            </Col>
            <Col span={12}>
              <InfoField
                label="Address"
                value={customer.address.formatted_address}
              />
            </Col>
            <Col span={12}>
              <InfoField label="House No" value={customer.address.house_no} />
            </Col>
            <Col span={12}>
              <InfoField label="Landmark" value={customer.address.landmark} />
            </Col>
            <Col span={12}>
              <InfoField
                label="Distance from Outlet"
                value={`${customer.by_road_distance} KM`}
                showCopy={false}
              />
            </Col>
          </Row>
          <Row gutter={[12, 12]}>
            <Col span={12}>
              <Space size="small" direction="vertical">
                <a href={customerAddressUrl} target="_blank" rel="noreferrer">
                  See customer address on map
                  <EnvironmentOutlined style={{ marginLeft: "0.5rem" }} />
                </a>
                <CopyableText
                  displayText="Copy Location"
                  text={`${customer.address.latitude}, ${customer.address.longitude}`}
                />
              </Space>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
